import { css } from '@emotion/react';

import { ReactNode } from 'react';

import { Radius, Spacing } from 'chatie-design-system';

const buttonCSS = ({
  width = 64,
  height = 64,
  top,
  left,
  right = Spacing.medium,
  bottom = Spacing.medium,
  borderRadius = Radius.round,
  backgroundColor = 'var(--theme-play-gra, linear-gradient(34.71deg, #20a2ae 3.8%, #5563e1 84.21%))',
  padding,
}: ButtonCSSProps) => css`
  position: fixed;
  display: flex;
  justify-content: center;
  padding: ${padding};
  align-items: center;
  width: ${width}px;
  height: ${height}px;
  top: ${top}px;
  left: ${left}px;
  right: ${right}px;
  bottom: ${bottom}px;
  border-radius: ${borderRadius}px;
  z-index: 98;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);
  background: ${backgroundColor};
`;

export interface ButtonCSSProps {
  width?: number;
  height?: number;
  top?: number;
  left?: number;
  right?: number;
  bottom?: number;
  backgroundColor?: string;
  color?: string;
  borderRadius?: number;
  padding?: string;
}

export interface FloatingButtonProps extends ButtonCSSProps {
  children: ReactNode | string;
  onClick?: () => void;
  className?: string;
}

const FloatingButton = (props: FloatingButtonProps) => {
  const { onClick, children, className } = props;

  return (
    <div css={buttonCSS({ ...props })} onClick={onClick} className={className}>
      {children}
    </div>
  );
};

export default FloatingButton;
